var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{ref:"formComponent",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_vm._t("default"),_vm._t("input-submit",[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"submit"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }